var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.011 512",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.608 512H8.457V170.164h106.151V512zM61.476 123.534C27.532 123.534 0 95.419 0 61.476 0 27.524 27.524 0 61.476 0s61.475 27.524 61.475 61.476c0 33.943-27.543 62.058-61.475 62.058zM511.897 512H405.975V345.596c0-39.658-.8-90.516-55.19-90.516-55.19 0-63.647 43.087-63.647 87.659V512H181.101V170.164h101.808v46.629h1.486c14.172-26.857 48.79-55.201 100.436-55.201 107.431 0 127.18 70.745 127.18 162.632V512h-.114z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default ForwardRef;